module.exports = __webpack_public_path__ + "media/surface_mount_carriers/pressure-holder-standard-1854f2db.png";